import { Stack } from 'expo-router';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { StandardMobileHeader } from 'components/app-header/mobile-header';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants/primitives';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function OffersLayout() {
  useStoreRequired(Boolean(useFlag(LaunchDarklyFlag.FORCE_RESTAURANT_SELECTION_FOR_REWARDS)));

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: primitive.bk.$mayoEggWhite },
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          header: () => <StandardMobileHeader />,
          headerShown: true,
        }}
      />
      {/* NOTE: modals are in (modals) */}
    </Stack>
  );
}
